// src/config/globalConfig.ts

export interface RuntimeConfig {
    client_id?: string;
    tenant_id?: string;
    appInsightsConnectionString?: string; // Add this field
    client_secret_key?: string;
    app_client_id?: string
    // Add other fields from your decrypted config here
}

class GlobalConfig {
    private static instance: GlobalConfig;
    private config: RuntimeConfig = {};

    private constructor() { }

    public static getInstance(): GlobalConfig {
        if (!GlobalConfig.instance) {
            GlobalConfig.instance = new GlobalConfig();
        }
        return GlobalConfig.instance;
    }

    public setConfig(newConfig: Partial<RuntimeConfig>) {
        this.config = { ...this.config, ...newConfig };
    }

    public getConfig(): RuntimeConfig {
        return this.config;
    }

    public getValue<T extends keyof RuntimeConfig>(key: T): RuntimeConfig[T] {
        return this.config[key];
    }
}

export const globalConfig = GlobalConfig.getInstance();